import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { SideBarToggleButton } from "./SideBarToggleButton";
import { pxToRem } from "../../../utils/styles/size";
import { LogoIcon } from "../../../icons";

interface SideBarTitleSectionProps {
  isExpanded: boolean;
  onClick: () => void;
}
export const SideBarTitleSection: React.FC<SideBarTitleSectionProps> = ({
  onClick,
  isExpanded,
}) => {
  return (
    <Flex
      className="justify-end @[220px]/sidebar:justify-between"
      h={pxToRem(36)}
      alignItems={"center"}
      width={"full"}
    >
      <Box
        pl={1}
        className="hidden @[220px]/sidebar:block"
      >
        <LogoIcon
          w={pxToRem(50)}
          h={2.5}
        />
      </Box>
      <SideBarToggleButton
        onClick={onClick}
        isExpanded={isExpanded}
      />
    </Flex>
  );
};
